import Rails from '@rails/ujs';
import 'font-awesome/css/font-awesome.css';

let accountListenerStarted = false;

export function start() {
  if (!accountListenerStarted) {
    accountListenerStarted = true;
    const syncAccounts = () => {
      const accountId = document.body.dataset.currentAccount;
      if (accountId === undefined) return;
      const key = 'mastodon.active-account';
      try { localStorage.setItem(key, accountId); } catch { /* Storage may be disabled. */ }
      window.addEventListener('storage', event => {
        if (event.key === key && event.newValue !== accountId) window.location.reload();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAccounts, { once: true });
    else syncAccounts();
  }

  require.context('../images/', true);

  try {
    Rails.start();
  } catch (e) {
    // If called twice
  }
}
